/* Shopify render time anchors every deal surface to the same clock. */
(() => {
  let offset = 0;
  const sync = epoch => {
    const server = Number(epoch) * 1000;
    if (Number.isFinite(server) && server > 0) offset = server - Date.now();
  };
  sync(document.body.dataset.serverNow);
  window.CheapUndiesDeal = Object.freeze({ now: () => Date.now() + offset, sync });
})();
